export default {
  id: null,
  cost_centre_id: null,
  delegation_order_id: null,
  user_id: "",
  task_id: null,
  task: "",
  custom_number: "",
  destination: [],
  destinationText: null,
  start_date: null,
  end_date: null,
  advances: [],
  transport: [],
  country: [],
  file: [],
  other: [],
  booking: [],
  project_id: null,
  external_customer_id: null,
  company_id: null,
  settlement_date: null,
  optima_category_code: null
};
